import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import removeImg from "../../../assets/images/remove-dark-icon.svg";
import formatText from "../../commonComponents/formatText/FormatText";

function DraggableChip({ id, index, number, label, onRemove }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 999 : 1,
    backgroundColor: "#ffffff",
    border:
      "1px solid #d1d5db" /* matches CommonChip's grey border (Tailwind gray-300) */,
  };

  const handleRemoveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.target.closest("button")) {
      onRemove(label);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center rounded-full px-2 py-[4px] ${
        isDragging ? "shadow-lg" : ""
      }`}
    >
      {/* Drag Handle */}
      <div
        {...attributes}
        {...listeners}
        className="flex items-center cursor-grab active:cursor-grabbing"
      >
        {/* Number Badge */}
        <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-btnBgColor rounded-full text-white text-tertiaryFontSize mr-2 -ml-1">
          {number}
        </div>
        {/* Label */}
        <div className="mr-2 select-none text-allfonts">
          {formatText(label)}
        </div>
      </div>

      {/* Remove Button */}
      <button
        onClick={handleRemoveClick}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        className="flex-shrink-0 p-1 rounded-full cursor-pointer"
        aria-label="Remove"
        type="button"
      >
        <img
          src={removeImg}
          alt="remove"
          className="w-[10px] h-[10px] pointer-events-none"
        />
      </button>
    </div>
  );
}

export default DraggableChip;
